import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import { IoChevronBack } from "react-icons/io5";
import { FaChessRook } from "react-icons/fa6";
// import { IoHeart } from "react-icons/io5";
// import { IoBarChart } from "react-icons/io5";
// import { PiMedalFill } from "react-icons/pi";
import { HiAcademicCap } from "react-icons/hi2";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa6";
import { IoBook } from "react-icons/io5";
// import { FaArchway } from "react-icons/fa6";
import { IoMdNotifications } from "react-icons/io";
import { FaCircleQuestion } from "react-icons/fa6";


interface IProps {
  className: string;
}

const AcademySiderbar: React.FC<IProps> = ({ className }) => {
  const location = useLocation();
  const activeLink = "bg-gray-300 text-black font-bold rounded-lg";
  const [showEducation, setShowEducation] = useState(false);

  return (
    <div>
      <div>
        <div className={`bg-white border-r  p-4  ${className}`}>
          <ul className="space-y-8 md:space-y-0 pt-4 text-color-light-gray font-semibold">
            <li
              onClick={() => setShowEducation(!showEducation)}
              className=" relative"
            >
              <Link
                to="#"
                className={`flex items-center md:p-4 md:py-4 justify-center md:justify-start ${location.pathname === "/academy" + "/academy/product"
                  ? activeLink
                  :
                  location.pathname === "/academy" + "/academy/architecture"
                    ? activeLink
                    : location.pathname === "/academy" + "/academy/blog"
                      ? activeLink
                      :
                      location.pathname.includes(
                        "/academy/blog-detail/"
                      )
                        ? activeLink
                        : ""
                  }}`}
              >
                <HiAcademicCap className="text-color-pink ml-1" size={25} />
                <span className="hidden md:block ml-2">Eğitim</span>
                {showEducation ? (
                  <FaChevronDown className=" ml-auto" />
                ) : (
                  <FaChevronRight className=" ml-auto" />
                )}
              </Link>

              {showEducation && (
                <div className="flex flex-col ml-0 md:ml-4 mt-2 text-xs md:text-xs justify-center items-center w-full z-30">
                  <Link
                    to={"/academy/academy/product"}
                    className="flex hover:bg-gray-200 p-2 group transition-all gap-x-2 w-full items-center"
                  >
                    <FaCircleQuestion
                      className="group-hover:text-color-pink hidden md:flex ml-1"
                      size={20}
                    />
                    <p className="group-hover:text-black">Tanıtım</p>
                  </Link>

                  <Link
                    to={"/academy/academy/architecture"}
                    className="flex hover:bg-gray-200 p-2 group transition-all gap-x-2 w-full items-center"
                  >
                    <FaChessRook
                      className="group-hover:text-color-pink ml-1 mb-1 hidden md:flex"
                      size={20}
                    />
                    <p className="group-hover:text-black">Mimari</p>
                  </Link>

                  <Link
                    to={"/academy/academy/blog"}
                    className="flex hover:bg-gray-200 p-2 group transition-all gap-x-2 w-full items-center"
                  >
                    <IoBook
                      className="group-hover:text-color-pink ml-1 hidden md:flex"
                      size={20}
                    />
                    <p className="group-hover:text-black">Blog</p>
                  </Link>
                </div>
              )}
            </li>

            <li>
              <Link
                to="/academy/academy/events"
                className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start ${location.pathname === "/academy" + "/academy/events"
                  ? activeLink
                  :
                  location.pathname.includes(
                    "/academy/events-detail/"
                  )
                    ? activeLink
                    : ""
                  }`}
              >
                <IoMdNotifications className="text-color-pink text-2xl" />
                <span className="hidden md:block ml-2">Etkinlikler</span>
              </Link>
            </li>

            {/* <li>
              <Link
                to="/academy/academy/trade"
                className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start ${
                  location.pathname === "/academy" + "/academy/trade"
                    ? activeLink
                    : ""
                }`}
              >
                <FaShoppingCart className="text-color-pink text-2xl" />
                <span className="hidden md:block ml-2">Ticaret</span>
              </Link>
            </li>

            <li>
              <Link
                to="/academy/academy/sales"
                className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start ${
                  location.pathname === "/academy" + "/academy/sales"
                    ? activeLink
                    : ""
                }`}
              >
                <IoBarChart className="text-color-pink text-2xl" />
                <span className="hidden md:block ml-2">Satış</span>
              </Link>
            </li>

            <li>
              <Link
                to="/academy/academy/sector"
                className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start ${
                  location.pathname === "/academy" + "/academy/sector"
                    ? activeLink
                    : ""
                }`}
              >
                <PiMedalFill className="text-color-pink text-2xl" />
                <span className="hidden md:block ml-2">Sektör</span>
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AcademySiderbar;
